import mensagens from "../locales"

const obterIdiomasSuportados = (): string[] => Object.keys(mensagens);

const idiomasSuportados = obterIdiomasSuportados();

export default idiomasSuportados